import * as React from "react";
import * as ReactDOM from "react-dom";
import { Picture, PictureList } from "./Editors/Pictures";
import { FileList } from "./Editors/FileList";
import { SFConnectionDTO, ComponentType, UserDTO } from "groopit-js";
import {
  InheritedDataEditorViewModel,
  SaveToSalesforceDataEditor,
} from "./Editors/SaveToSalesforceDataEditor";
import { FollowUpRequestDataEditor } from "./Editors/FollowUpRequestDataEditor";
import { NoteDataEditor } from "./Editors/NoteDataEditor";
import { MultipleChoiceDataEditor } from "./Editors/MultipleChoiceDataEditor";
import { DateTimeDataEditor } from "./Editors/DateTimeDataEditor";
import { DecimalDataEditor } from "./Editors/DecimalDataEditor";
import { IFileModelDTO, IPictureModelDTO } from "groopit-js/client";

//
// Wires up the React components necessary for creating or editing a post
//
document.querySelectorAll<HTMLElement>(".pictureset").forEach((c) => {
  const description = c.dataset.description as string;
  const pictures: IPictureModelDTO[] = c.dataset.pictures
    ? JSON.parse(c.dataset.pictures)
    : undefined;
  const inputPrefix = c.dataset.inputprefix;
  const pictureImageBase = c.dataset.pictureimagebase;
  const disabled = c.dataset.disabled === "True";
  if (pictures && inputPrefix && pictureImageBase) {
    ReactDOM.render(
      <PictureList
        description={description}
        inputPrefix={inputPrefix}
        pictures={pictures}
        pictureImageBase={pictureImageBase}
        disabled={disabled}
      />,
      c,
    );
  }
});

document.querySelectorAll<HTMLElement>(".picture").forEach((c) => {
  const description = c.dataset.description as string;
  const picture: IPictureModelDTO = c.dataset.picture
    ? JSON.parse(c.dataset.picture)
    : undefined;
  const inputPrefix = c.dataset.inputprefix;
  const pictureImageBase = c.dataset.pictureimagebase;
  const disabled = c.dataset.disabled === "True";
  if (inputPrefix && pictureImageBase) {
    ReactDOM.render(
      <Picture
        description={description}
        inputPrefix={inputPrefix}
        picture={picture}
        pictureImageBase={pictureImageBase}
        disabled={disabled}
      />,
      c,
    );
  }
});

document.querySelectorAll<HTMLElement>(".note-data-editor").forEach((c) => {
  const parentComponentString = c.dataset.parentComponent;
  const rawTags = JSON.parse(c.dataset.tags as string);
  const tags: { [key: string]: UserDTO } = {};
  // Stupid case conversion for API objects
  for (const key in rawTags) {
    if (Object.prototype.hasOwnProperty.call(rawTags, key))
      tags[key] = rawTags[key] ? UserDTO.fromJS(rawTags[key]) : new UserDTO();
  }

  ReactDOM.render(
    <NoteDataEditor
      description={c.dataset.description as string}
      parentComponent={
        parentComponentString && parentComponentString !== "null"
          ? ComponentType[parentComponentString as keyof typeof ComponentType]
          : undefined
      }
      disabled={c.dataset.disabled === "True"}
      baseName={c.dataset.baseName as string}
      groupId={c.dataset.groopId as string}
      tags={tags}
      rawText={JSON.parse(c.dataset.rawText as string)}
    />,
    c,
  );
});

document
  .querySelectorAll<HTMLElement>(".multiplechoice-data-editor")
  .forEach((c) => {
    ReactDOM.render(
      <MultipleChoiceDataEditor
        baseName={c.dataset.baseName as string}
        disabled={c.dataset.disabled === "True"}
        multiple={c.dataset.multiple === "True"}
        description={c.dataset.description as string}
        optionList={JSON.parse(c.dataset.optionList as string)}
        allowUpdates={c.dataset.allowUpdates === "True"}
        choices={JSON.parse(c.dataset.choices as string)}
      />,
      c,
    );
  });

document.querySelectorAll<HTMLElement>(".datetime-data-editor").forEach((c) => {
  ReactDOM.render(
    <DateTimeDataEditor
      baseName={c.dataset.baseName as string}
      disabled={c.dataset.disabled === "True"}
      description={c.dataset.description as string}
      dateOnly={c.dataset.dateOnly === "True"}
      sideBySide={true}
      timestamp={JSON.parse(c.dataset.timestamp as string)}
    />,
    c,
  );
});

document.querySelectorAll<HTMLElement>(".decimal-data-editor").forEach((c) => {
  const parentComponentString = c.dataset.parentComponent;
  ReactDOM.render(
    <DecimalDataEditor
      baseName={c.dataset.baseName as string}
      disabled={c.dataset.disabled === "True"}
      description={c.dataset.description as string}
      parentComponent={
        parentComponentString && parentComponentString !== "null"
          ? ComponentType[parentComponentString as keyof typeof ComponentType]
          : undefined
      }
      places={Number.parseInt(c.dataset.places as string)}
      format={c.dataset.format as string}
      number={
        c.dataset.number ? Number.parseFloat(c.dataset.number) : undefined
      }
    />,
    c,
  );
});

document.querySelectorAll<HTMLElement>(".fileset").forEach((c) => {
  const description = c.dataset.description as string;
  const files: IFileModelDTO[] = c.dataset.files
    ? JSON.parse(c.dataset.files)
    : undefined;
  const inputPrefix = c.dataset.inputprefix;
  const disabled = c.dataset.disabled === "True";
  if (files && inputPrefix) {
    ReactDOM.render(
      <FileList
        description={description}
        inputPrefix={inputPrefix}
        files={files}
        disabled={disabled}
      />,
      c,
    );
  }
});

document
  .querySelectorAll<HTMLElement>(".save-to-salesforce-data-editor")
  .forEach((el) => {
    const inheritedData = new Array<InheritedDataEditorViewModel>();
    for (const item of JSON.parse(el.dataset.inheritedData as string)) {
      inheritedData.push(item as InheritedDataEditorViewModel);
    }
    const connection = JSON.parse(el.dataset.connection as string);
    ReactDOM.render(
      <SaveToSalesforceDataEditor
        baseName={el.dataset.baseName as string}
        assignmentId={el.dataset.assignmentId as string}
        componentId={parseInt(el.dataset.componentId as string)}
        description={el.dataset.description as string}
        connection={connection ? SFConnectionDTO.fromJS(connection) : undefined}
        hasInheritedData={el.dataset.hasInheritedData === "True"}
        primaryDataType={el.dataset.primaryDataType as string}
        primaryDataFieldName={el.dataset.primaryDataFieldName as string}
        primaryDataLabel={el.dataset.primaryDataLabel as string}
        primaryDataId={el.dataset.primaryDataId as string}
        primaryDataDisplayName={el.dataset.primaryDataDisplayName as string}
        inheritedData={inheritedData}
        disabled={el.dataset.disabled === "True"}
      />,
      el,
    );
  });

document
  .querySelectorAll<HTMLElement>(".follow-up-request-data-editor")
  .forEach((el) => {
    ReactDOM.render(
      <FollowUpRequestDataEditor
        baseName={el.dataset.baseName as string}
        description={el.dataset.description as string}
        required={el.dataset.required === "True"}
        requested={el.dataset.requested === "True"}
        disabled={el.dataset.disabled === "True"}
      />,
      el,
    );
  });
